"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@Const/common");
const DspDataSection = (props) => {
    const { recordingData, dspLink } = props;
    const { dsp, senderResourceId } = recordingData;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "section-header" },
            react_1.default.createElement("img", { src: common_1.ICONS.recordingDSP }),
            react_1.default.createElement("h5", null, "DSP Data")),
        react_1.default.createElement("div", { className: 'details dsp-details' },
            react_1.default.createElement("div", { className: 'vertical-detail' },
                react_1.default.createElement("p", { className: "underline dsp-label" }, "DSP Name"),
                react_1.default.createElement("p", { className: "semi-bold" }, dsp[0].toUpperCase() || 'N/A')),
            react_1.default.createElement("div", { className: 'vertical-detail' },
                react_1.default.createElement("p", { className: "underline dsp-label" }, "DSP Identifier"),
                react_1.default.createElement("p", { className: "semi-bold" }, senderResourceId || 'N/A')),
            react_1.default.createElement("div", { className: 'vertical-detail' },
                react_1.default.createElement("p", { className: "underline dsp-label" }, "DSP Audio Link"),
                dspLink ? (react_1.default.createElement("a", { className: "underline", target: "_blank", href: dspLink, rel: "noreferrer" }, dspLink)) : (react_1.default.createElement("p", { className: "not-available" }, "Not Available"))))));
};
exports.default = DspDataSection;
